const highlights = [
  { icon: 'ri-award-line', label: 'Sertifiserte behandlere' },
  { icon: 'ri-heart-line', label: 'Individuell tilpasning' },
  { icon: 'ri-leaf-line', label: 'Kvalitetsprodukter' },
  { icon: 'ri-star-line', label: 'Enestående resultater' },
];

export default function About() {
  return (
    <section id="about" className="py-20 md:py-28 bg-[#0c0804]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-10">
        {/* Top divider */}
        <div className="w-full h-px bg-gradient-to-r from-transparent via-[#c9a84c]/30 to-transparent mb-14 md:mb-20" />

        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
          {/* Left — image */}
          <div className="flex-shrink-0 w-full lg:w-[420px]">
            <div className="relative mx-auto max-w-sm lg:max-w-none">
              {/* Decorative borders */}
              <div className="absolute -inset-2 md:-inset-3 rounded-3xl border border-[#c9a84c]/20" aria-hidden="true" />
              <div className="absolute -inset-4 md:-inset-6 rounded-3xl border border-[#c9a84c]/8" aria-hidden="true" />

              <div className="relative rounded-2xl overflow-hidden w-full h-[300px] sm:h-[380px] md:h-[440px] lg:h-[480px] bg-[#1a1008]">
                <img
                  src="https://storage.readdy-site.link/project_files/f7a91cb2-16ed-4f1e-969d-5ece724c23c9/81c2abbe-ea2e-48f1-9411-bb76a65510fd_hairPlain.png?v=5f41a1593343a5575d6a4e0a2dcfc9cf"
                  alt="Equi AS klinikk – profesjonell skjønnhetsbehandling i Moelv"
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                  width="420"
                  height="480"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0c0804]/60 via-transparent to-transparent" />
              </div>

              {/* Floating badge */}
              <div className="absolute -bottom-4 -right-2 sm:-bottom-5 sm:-right-5 bg-[#c9a84c] text-[#0e0a07] rounded-2xl px-4 py-3 md:px-5 md:py-4">
                <p className="text-xl md:text-2xl font-bold leading-none">10+</p>
                <p className="text-xs font-medium mt-0.5 whitespace-nowrap">Års erfaring</p>
              </div>
            </div>
          </div>

          {/* Right — content */}
          <div className="flex-1 mt-6 lg:mt-0">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-[#c9a84c]/30 bg-[#c9a84c]/8 mb-5 md:mb-6">
              <span className="text-[#c9a84c] text-xs tracking-[0.2em] uppercase font-medium">Om Oss</span>
            </div>

            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white leading-tight mb-5 md:mb-6">
              En unik klinikk
              <br />
              <span className="text-[#c9a84c]">i Rudshøgda</span>
            </h2>

            <p className="text-white/60 text-sm md:text-base leading-relaxed mb-4 md:mb-6">
              Equi Velvære er en populær skjønnhetssalong kjent for sin ekspertise og innovasjon innen skjønnhetspleie. Med et sterkt fokus på kundens velvære og skjønnhet, tilbyr vi et bredt spekter av tjenester — fra profesjonelle skjønnhetsbehandlinger til personlig tilpasset rådgivning.
            </p>

            <p className="text-white/60 text-sm md:text-base leading-relaxed mb-8 md:mb-10">
              Vi forstår at hver person har unike behov, uavhengig av alder, miljø, livsstil eller genetikk. Derfor tilpasser vi alltid våre behandlinger for å imøtekomme individuelle krav og forplikter oss til å levere løsninger som effektivt pleier og fremhever huden på et personlig nivå.
            </p>

            {/* Highlights */}
            <div className="grid grid-cols-2 gap-3 md:gap-4 mb-8 md:mb-10">
              {highlights.map((h) => (
                <div key={h.label} className="flex items-center gap-2.5 md:gap-3">
                  <div className="w-8 h-8 md:w-9 md:h-9 flex items-center justify-center rounded-full bg-[#c9a84c]/15 flex-shrink-0">
                    <i className={`${h.icon} text-[#c9a84c] text-sm`} />
                  </div>
                  <span className="text-white/70 text-xs md:text-sm">{h.label}</span>
                </div>
              ))}
            </div>

            {/* Hours */}
            <div className="p-4 md:p-5 rounded-2xl border border-white/8 bg-white/3">
              <p className="text-[#c9a84c] text-xs tracking-[0.2em] uppercase font-medium mb-3">Åpningstider</p>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 sm:gap-4">
                <div>
                  <p className="text-white text-sm font-medium">Mandag – Fredag</p>
                  <p className="text-white/50 text-sm">09:00 – 20:00</p>
                </div>
                <div className="hidden sm:block w-px bg-white/10 mx-auto" />
                <div>
                  <p className="text-white text-sm font-medium">Lørdag</p>
                  <p className="text-white/50 text-sm">10:00 – 16:00</p>
                </div>
                <div className="hidden sm:block w-px bg-white/10 mx-auto" />
                <div>
                  <p className="text-white text-sm font-medium">Søndag</p>
                  <p className="text-white/50 text-sm">Stengt</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom divider */}
        <div className="w-full h-px bg-gradient-to-r from-transparent via-[#c9a84c]/30 to-transparent mt-14 md:mt-20" />
      </div>
    </section>
  );
}